import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormText({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
}) {
  return (
    <Form.TextArea
      name={id}
      label={name}
      description={description}
      defaultValue={value}
      data-test="form-text"
      placeholder="Enter a value"
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
}

FormText.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

FormText.defaultProps = {
  description: "",
  value: "",
  required: true,
  errorMessage: "Please enter a value",
  disabled: false,
};

export default FormText;
